import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import useHttp from "../../../../hook/use-http";
import { API_URL_MAIN } from "../../../../constants/driveglobalfilterinitalstates_bus";
import moment from 'moment';
import WaterMark1 from '../WaterMark1';

export default function ThirdSection(props) {

  const { isLoading, error, sendReq: fetchData } = useHttp();
  let { title, template_id, show, soarting, gloablfilter } = props;
  let temp = [];

  const [duration, setDuration] = useState("7D");
  const [topupSelected, setTopupSelected] = useState("Depot_Name");
  const [sDate, setSDate] = useState();
  const [eDate, setEDate] = useState();
  const [tableData, setTableData] = useState();
  const [topping, setTopping] = useState("Drive");

  const enddate = moment().utc().format('YYYY-MM-DD[T]00:00:00.000[Z]')
  const startdate = moment().utc().subtract(7, 'days').startOf('day').format('YYYY-MM-DD[T]00:00:00.000[Z]');

  const handleDurationSelection = async (durationValue) => {
    await updateDates(durationValue);
  }

  const updateDates = async (durationValue) => {
    setDuration(durationValue);
    if (durationValue === "7D") {
      setEDate(moment().format('YYYY-MM-DD'));
      setSDate(moment().subtract(7, 'days').format('YYYY-MM-DD'));
    } else if (durationValue === '1M') {
      setEDate(moment().format('YYYY-MM-DD'));
      setSDate(moment().subtract(31, 'days').format('YYYY-MM-DD'));
    } else if (durationValue === '3M') {
      setEDate(moment().format(('YYYY-MM-DD')));
      setSDate(moment().subtract(91, 'days').format('YYYY-MM-DD'));
    } else if (durationValue === '6M') {
      setEDate(moment().format('YYYY-MM-DD'));
      setSDate(moment().subtract(183, 'days').format('YYYY-MM-DD'));
    } else if (durationValue === '1Y') {
      setEDate(moment().format('YYYY-MM-DD'));
      setSDate(moment().subtract(366, 'days').format('YYYY-MM-DD'));
    }
  }

  useEffect(() => {
    if (topping === 'Drive') {
      fetchData(
        {
          url: API_URL_MAIN + "trend_analysis_drive_bus/datatableTrend",
          body: {
            filterdata: {
              "CITY": props.gloablfilter.CITY,
              "DEPO": props.gloablfilter.DEPO,
              "LOB": [],
              "PL": [],
              "PPL": [],
              "SOC": 0,
              "VIN_NUM": [],
              "endDate": eDate ? eDate : enddate,
              "pageSelected": 1,
              "startDate": sDate ? sDate : startdate,
              "AIR_VENTILATION": "",
              "topupSelected": topupSelected,
            }
          },
        },
        responceDataDate
      );
    } else {
      fetchData(
        {
          url: API_URL_MAIN + "trend_analysis_drive_bus/datatableRegTrend",
          body: {
            filterdata: {
              "CITY": props.gloablfilter.CITY,
              "DEPO": props.gloablfilter.DEPO,
              "LOB": [],
              "PL": [],
              "PPL": [],
              "SOC": 0,
              "VIN_NUM": [],
              "endDate": eDate ? eDate : enddate,
              // "endDate": "2023-11-08",
              "pageSelected": 1,
              "startDate": sDate ? sDate : startdate,
              // "startDate": "2023-10-15",
              "AIR_VENTILATION": "",
              "topupSelected": topupSelected,
            }
          },
        },
        responceDataDate
      );
    }

  }, [gloablfilter, sDate, eDate, duration, topupSelected, topping]);

  const responceDataDate = (data) => {
    setTableData(data)
  }

  const column = [
    { name: "Particulars", selector: row => row.key[topupSelected] || "-", sortable: true, width: '11%', center: true },
    { name: "No. of vehicle count", selector: row => row.Total_vehicles.value || "-", sortable: true, width: '15%', center: true },
    { name: "No. of discharge cycle", selector: row => row.vehicleId.doc_count || "-", sortable: true, width: '16%', center: true },
    { name: "Sum Distance(km)", selector: row => row.distanceInKM.value || "-", sortable: true, width: '14%', center: true },
    { name: "Range(km)", selector: row => (row.Range.values && row.Range.values["50.0"] ? row.Range.values["50.0"].toFixed(2) : "-"), sortable: true, width: '11%', center: true },
    { name: "Discharge Soc(%)", selector: row => (row.dischargeSoc_median && row.dischargeSoc_median.values["50.0"] ? row.dischargeSoc_median.values["50.0"].toFixed(2) : "-"), sortable: true, width: '14%', center: true },
    { name: "kWh", selector: row => (row.NetkWh_median && row.NetkWh_median.values["50.0"] ? row.NetkWh_median.values["50.0"].toFixed(2) : "-"), sortable: true, width: '9%', center: true },
    { name: "kWh/km", selector: row => (row.whPerKM_median && row.whPerKM_median.values["50.0"] ? row.whPerKM_median.values["50.0"].toFixed(2) : "-"), sortable: true, width: '10%', center: true },
  ];

  const column1 = [
    { name: "Particulars", selector: row => row.key[topupSelected + ".keyword"] || "-", sortable: true, width: '9%', center: true },
    { name: "Vehicle Count", selector: row => row.Total_vehicles.value || "-", sortable: true, width: '10%', center: true },
    { name: "Dis. Cycle", selector: row => row.vehicleId.doc_count || "-", sortable: true, width: '10%', center: true },
    { name: "Sum Dis.(km)", selector: row => row.distanceInKM.value || "-", sortable: true, width: '10%', center: true },
    { name: "Range(km)", selector: row => (row.Range.values && row.Range.values["50.0"] ? row.Range.values["50.0"].toFixed(2) : "-"), sortable: true, width: '9%', center: true },
    { name: "Dis. Soc(%)", selector: row => (row.dischargeSoc_median && row.dischargeSoc_median.values["50.0"] ? row.dischargeSoc_median.values["50.0"].toFixed(2) : "-"), sortable: true, width: '10%', center: true },
    { name: "Net_Kwh ", selector: row => (row.NetkWh_median && row.NetkWh_median.values["50.0"] ? row.NetkWh_median.values["50.0"].toFixed(2) : "-"), sortable: true, width: '7%', center: true },
    // { name: "kWh/km", selector: row => (row.whPerKM_median && row.whPerKM_median.values["50.0"] ? row.whPerKM_median.values["50.0"].toFixed(2) : "-"), sortable: true, width: '10%', center: true },
    { name: "Net Cons. kWh/km", selector: row => (row.Net_consumption && row.Net_consumption.value ? row.Net_consumption.value.toFixed(2) : "-"), sortable: true, width: '12%', center: true },
    { name: "Regen.kWh/km", selector: row => (row.Traction_km && row.Traction_km.value ? row.Traction_km.value.toFixed(2) : "-"), sortable: true, width: '11%', center: true },
    { name: "Ener.Cons.kWh/km", selector: row => (row.Energy_cons_kwh && row.Energy_cons_kwh.value ? row.Energy_cons_kwh.value.toFixed(2) : "-"), sortable: true, width: '12%', center: true },
  ];

  const columns = [
    { name: "Vin", selector: row => row.key.vehicleId || "-", sortable: true, width: '13%', center: true },
    { name: "Particulars", selector: row => row.key[topupSelected] || "-", sortable: true, width: '10%', center: true },
    { name: "Vehicle count", selector: row => row.Total_vehicles.value || "-", sortable: true, width: '12%', center: true },
    { name: "Discharge cycle", selector: row => row.vehicleId.doc_count || "-", sortable: true, width: '13%', center: true },
    { name: "Distance(km)", selector: row => row.distanceInKM.value || "-", sortable: true, width: '12%', center: true },
    { name: "Range(km)", selector: row => (row.Range.values && row.Range.values["50.0"] ? row.Range.values["50.0"].toFixed(2) : "-"), sortable: true, width: '10%', center: true },
    { name: "Discharge Soc(%)", selector: row => (row.dischargeSoc_median && row.dischargeSoc_median.values["50.0"] ? row.dischargeSoc_median.values["50.0"].toFixed(2) : "-"), sortable: true, width: '14%', center: true },
    { name: "kWh", selector: row => (row.NetkWh_median && row.NetkWh_median.values["50.0"] ? row.NetkWh_median.values["50.0"].toFixed(2) : "-"), sortable: true, width: '7%', center: true },
    { name: "kWh/km", selector: row => (row.whPerKM_median && row.whPerKM_median.values["50.0"] ? row.whPerKM_median.values["50.0"].toFixed(2) : "-"), sortable: true, width: '9%', center: true },
  ];

  const columns1 = [
    { name: "Vin", selector: row => row.key.vehicleId || "-", sortable: true, width: '13%', center: true },
    { name: "Reg. No.", selector: row => row.key[topupSelected + ".keyword"] || "-", sortable: true, width: '10%', center: true },
    // { name: "Veh. Count", selector: row => row.Total_vehicles.value || "-", sortable: true, width: '7%', center: true },
    { name: "Dis Cycle", selector: row => row.vehicleId.doc_count || "-", sortable: true, width: '7%', center: true },
    { name: "Sum Dis.(km)", selector: row => row.distanceInKM.value || "-", sortable: true, width: '10%', center: true },
    { name: "Range(km)", selector: row => (row.Range.values && row.Range.values["50.0"] ? row.Range.values["50.0"].toFixed(2) : "-"), sortable: true, width: '8%', center: true },
    { name: "Dis. Soc(%)", selector: row => (row.dischargeSoc_median && row.dischargeSoc_median.values["50.0"] ? row.dischargeSoc_median.values["50.0"].toFixed(2) : "-"), sortable: true, width: '9%', center: true },
    { name: "Net_Kwh ", selector: row => (row.NetkWh_median && row.NetkWh_median.values["50.0"] ? row.NetkWh_median.values["50.0"].toFixed(2) : "-"), sortable: true, width: '8%', center: true },
    // { name: "kWh/km", selector: row => (row.whPerKM_median && row.whPerKM_median.values["50.0"] ? row.whPerKM_median.values["50.0"].toFixed(2) : "-"), sortable: true, width: '9%', center: true },
    { name: "Net Cons. kWh/km", selector: row => (row.Net_consumption && row.Net_consumption.value ? row.Net_consumption.value.toFixed(2) : "-"), sortable: true, width: '12%', center: true },
    { name: "Regen.kWh/km", selector: row => (row.Traction_km && row.Traction_km.value ? row.Traction_km.value.toFixed(2) : "-"), sortable: true, width: '10%', center: true },
    { name: "Ener.Cons.kWh/km", selector: row => (row.Energy_cons_kwh && row.Energy_cons_kwh.value ? row.Energy_cons_kwh.value.toFixed(2) : "-"), sortable: true, width: '13%', center: true },
  ];


  const customStyles = {
    table: {
      style: {
        border: '1px solid #e6e6e6', // Set the border color for the table
      },
    },
    headRow: {
      style: {
        backgroundColor: '#D4DFEB',
        color: '#02559b',
        minHeight: '40px'
      },
    },
    headCells: {
      style: {
        fontSize: '13px',
        fontWeight: '600',
        paddingLeft: '4px', // override the cell padding for data cells
        paddingRight: '4px',
      }
    },
    rows: {
      style: {
        minHeight: '40px',// override the row height
      },
    },
    cells: {
      style: {
        paddingLeft: '4px', // override the cell padding for data cells
        paddingRight: '4px',
        // borderRight: '1px solid #e6e6e6',

      },
    },
    pagination: {
      style: {
        backgroundColor: '', // Set the background color for the pagination section
      },
    },
  }

  const conditionalRowStyles = [
    {
      when: (rowIndex) => rowIndex % 2 === 0,
      style: {
        '&:hover': {
          cursor: 'pointer',
        },
      },
    },
    {
      when: (rowIndex) => rowIndex % 2 !== 0,
      style: {
        '&:hover': {
          cursor: 'pointer',
        },
      },
    },
  ];

  const changeTopupTrigger = (topup) => {
    setTopupSelected(topup)
  }

  const onRadioChange = (e) => {
    setTopping(e.target.value);
  }

  return (
    <div className='container-fluid mt-3'>
      <div className='row mb-3' style={{ backgroundColor: "#fff", boxShadow: "0px 3px 6px #00000027", borderRadius: "5px" }}>
        <div className='row'>

          <div className='col-md-2'>
            <span><b className='pt-2 pl-2' style={{ fontSize: "20px", float: "left" }}>Vehicle Details</b></span>
          </div>

          <div className='col-md-5 pt-2 tex-start'>
            <div className="form-check form-check-inline bus">
              <input
                className="form-check-input"
                type="radio"
                name="DriveTable"
                id="DriveTable"
                value="Drive"
                checked={topping === "Drive"}
                onClick={onRadioChange}
              />
              <label className="form-check-label" htmlFor="FaultyVehicleCount">
                Drive
              </label>
            </div>
            <div className="form-check form-check-inline bus">
              <input
                className="form-check-input"
                type="radio"
                name="EnergyTable"
                id="EnergyTable"
                value="Energy"
                checked={topping === "Energy"}
                onClick={onRadioChange}
              />
              <label className="form-check-label" htmlFor="FaultyVehicleCount">
                Regeneration
              </label>
            </div>
          </div>

          <div className='col-md-5'>
            <div className='row mt-2'>
              <div className='col-md-5'></div>
              <div className='col-md-3'>
                <select style={{ backgroundColor: "#efefef" }}
                  className="form-select form-select-sm"
                  aria-label="Default select example"
                  onChange={(event) => changeTopupTrigger(event.target.value)}
                  value={topupSelected}
                >
                  <option value="Depot_Name">Depot</option>
                  <option value="DLR_ORG_CITY">City</option>
                  <option value="vehicle_registration_number">Vin</option>
                </select>
              </div>
              <div className='col-md-4'>
                <select style={{ backgroundColor: "#efefef" }}
                  className="form-select form-select-sm"
                  aria-label="Default select example"
                  onChange={(event) => handleDurationSelection(event.target.value)}
                  value={duration}
                >
                  <option value="7D">Last 7 days</option>
                  <option value="1M">Last 1 month</option>
                  <option value="3M">Last 3 months</option>
                  <option value="6M">Last 6 months</option>
                  <option value="1Y">Last 1 year</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* <WaterMark1 /> */}
        <div className='row' style={{ paddingLeft: "30px", paddingTop: "10px" }}>
          <div style={{ paddingRight: "0px" }}>
            <div style={{ height: "auto", width: "auto", paddingRight: "0px" }}>
              <div className="">
                {/* <WaterMark  style={{marginTop:"100px"}}/> */}
                {
                  (topping === 'Drive') ?
                    <DataTable
                      columns={topupSelected === "vehicle_registration_number" ? columns : column}
                      data={tableData}
                      customStyles={customStyles}
                      pagination
                      paginationPerPage={5}
                      paginationRowsPerPageOptions={[5, 10, 15, 20]}
                      conditionalRowStyles={conditionalRowStyles}
                    />
                    :
                    <DataTable
                      columns={topupSelected === "vehicle_registration_number" ? columns1 : column1}
                      data={tableData}
                      customStyles={customStyles}
                      pagination
                      paginationPerPage={5}
                      paginationRowsPerPageOptions={[5, 10, 15, 20]}
                      conditionalRowStyles={conditionalRowStyles}
                    />
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
